import Splide from "@splidejs/splide";
import { initFilterForm } from "./components/filter-form.js";

function initSliderFormations(context) {

	initFilterForm(context);
	initFilterFormAction(context);
}

// Front-end
document.addEventListener("DOMContentLoaded", () => initSliderFormations());

// Gutenberg / ACF editor
if (window.acf) {
	window.acf.addAction("render_block_preview/type=bloc-slider-formations", ($block) => {
		initSliderFormations($block && $block.jquery ? $block.get(0) : $block);
	});
}

function initFilterFormAction(context) {
	const root = context && typeof context.querySelectorAll === "function" ? context : document;

	root.querySelectorAll(".bloc-slider-formations ").forEach((el) => {

		const form = el.querySelector(`.form-filters--slider`)
		const splide = el.querySelector(`.splide-formations`)

		const splideSlider = new Splide(splide, {
			perPage: 3.5,
			gap: "25px",
			pagination: true,
			arrows: true,
			snap: true,
			focus: "left",
			autoplay: false,
			speed: 700,
			focus: 0,
			omitEnd: true,
			breakpoints: {
				1024: { perPage: 2.5, gap: "25px" },
				640: { perPage: 1, gap: "12px" },
			},
		});

		splideSlider.mount();

	

		const filterCheckboxes = el.querySelectorAll('[data-filter-type]');
		const filterableBlocks = el.querySelectorAll('[data-univers], [data-niveau]');

		form.addEventListener("submit", (e) => {
			e.preventDefault()
			applyFilters(filterCheckboxes, filterableBlocks)
			splide.refresh()
		});

	});
}


function getActiveFilters(filterCheckboxes) {
	const filters = {};

	filterCheckboxes.forEach(checkbox => {
		if (!checkbox.checked) return;

		const type = checkbox.dataset.filterType;
		const value = checkbox.value;

		if (!filters[type]) {
			filters[type] = [];
		}

		filters[type].push(value);
	});

	return filters;
}

function applyFilters(filterCheckboxes, filterableBlocks) {

	const activeFilters = getActiveFilters(filterCheckboxes);

	console.log(filterableBlocks);

	filterableBlocks.forEach(block => {
		const isVisible = Object.entries(activeFilters).every(([type, selectedValues]) => {
			const blockValues = block.dataset[type]
				? block.dataset[type].split(',').map(v => v.trim())
				: [];

			// OR intra-filtre : au moins une valeur du bloc correspond aux valeurs sélectionnées
			return selectedValues.some(selected => blockValues.includes(selected));
		});

		block.style.display = isVisible ? '' : 'none';
	});
}








